export const server = "http://jjayai-0da2b868a568.herokuapp.com:8000/";
// export const server = "http://localhost:8000/";
